import { preventImplicitSubmit } from "../../../../../app/javascript/keyboard/form_keys"
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["form", "itemsContainer"]

    connect() {
        console.log("connecting buy list controller")
        this.formTarget.addEventListener("keydown", preventImplicitSubmit)

    }

    removeItem(event) {
        event.preventDefault()
        const wrapper = event.target.closest(".item-container")
        const destroyField = wrapper.querySelector("input[name*='_destroy']")

        if (destroyField) {
            // mark for deletion and hide
            destroyField.value = "1"
            wrapper.style.display = "none"
        } else {
            // new item: just remove from DOM
            wrapper.remove()
        }
    }

    addSupplier(event) {
        console.log("Add supplier event")
        event.preventDefault()
        const originalRow = event.target.closest(".item-container")
        // Clone the element
        const clone = originalRow.cloneNode(true)

        // Detect old index from id or name
        const sample = originalRow.querySelector("[id],[name]")
        let oldIndex = "0"

        if (sample) {
            const idMatch = (sample.id || "").match(/buy_list_buy_list_lines_attributes_(\d+)/)
            const nameMatch = (sample.name || "").match(/buy_list\[buy_list_lines_attributes\]\[(\d+)\]/)

            if (idMatch) oldIndex = idMatch[1]
            if (nameMatch) oldIndex = nameMatch[1]
        }

        // New index (timestamp or UUID)
        const newIndex = Date.now().toString()

        // Remove parent-info elements before string replacement
        clone.querySelectorAll(".parent-info").forEach(el => el.remove())

        // --- 🔥 FULL STRING REPLACEMENT ---
        let html = clone.outerHTML

        // Replace for IDs (Rails style)
        html = html.replace(
            new RegExp(`buy_list_buy_list_lines_attributes_${oldIndex}`, "g"),
            `buy_list_buy_list_lines_attributes_${newIndex}`
        )

        // Replace for name attributes
        html = html.replace(
            new RegExp(`\\[buy_list_lines_attributes\\]\\[${oldIndex}\\]`, "g"),
            `[buy_list_lines_attributes][${newIndex}]`
        )

        html = html.replace(
            new RegExp(`buy_list\\[buy_list_lines_attributes\\]\\[${oldIndex}\\]`, "g"),
            `buy_list[buy_list_lines_attributes][${newIndex}]`
        )

        // Re-create the DOM node from updated HTML
        const wrapper = document.createElement("tbody") // any temp wrapper
        wrapper.innerHTML = html
        const newRow = wrapper.firstElementChild

        // Clear non-hidden values
        newRow.querySelectorAll("input, select, textarea").forEach(el => {
            if (el.type !== "hidden") el.value = ""
            if (/\[id]$/.test(el.name)) el.value = ""  // clear primary key for cloned rows
        })

        // Insert after original
        originalRow.after(newRow)
    }

}
